import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between w-full" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = {
  class: "",
  value: "ref",
  selected: "",
  disabled: ""
}
const _hoisted_6 = {
  class: "",
  value: "private"
}
const _hoisted_7 = {
  class: "",
  value: "public"
}
const _hoisted_8 = {
  class: "",
  value: "public not bookable"
}

import { PropType, computed, ref, onMounted } from "vue";
import { Club } from "../../types";


export default /*#__PURE__*/_defineComponent({
  __name: 'ClubVisibilitySwitch',
  props: {
  club: {
    type: Object as PropType<Club>,
    required: true,
  },
},
  emits: ["change"],
  setup(__props, { emit: emits }) {

const props = __props;




const visibility = ref("ref");

const type = computed(() => {
  if (visibility.value === "public") {
    return "bg-alert-success border-alert-success-600";
  }

  if (visibility.value === "public not bookable") {
    return "bg-alert-warning border-alert-warning-400";
  }

  return "bg-alert-secondary border-[#D3D6D8]";
});

async function emitClubChange() {
  return emits("change", visibility.value);
}

onMounted(() => {
  if (!props.club.visibility) {
    visibility.value = "private";
  }

  if (props.club.visibility && !props.club.bookable) {
    visibility.value = "public not bookable";
  }

  if (props.club.visibility && props.club.bookable) {
    visibility.value = "public";
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_unref(type), 'flex items-center p-4 justify-between border rounded text-alert-secondary-600'])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        (!__props.club.visibility && !__props.club.bookable)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$t("this-club-is-private")), 1))
          : _createCommentVNode("", true),
        (__props.club.visibility && !__props.club.bookable)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t("this-club-is-public-and-not-accepting-bookings")), 1))
          : _createCommentVNode("", true),
        (__props.club.visibility && __props.club.bookable)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.$t("this-club-is-public-and-accepting-bookings")), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        _withDirectives(_createElementVNode("select", {
          id: "",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((visibility).value = $event)),
          onChange: emitClubChange,
          class: "text-black border w-full rounded focus:outline-none focus:shadow-outline-primary font-normal transition duration-50 ease-in px-3 py-1.5 pr-8 h-10 border-gray-600",
          required: ""
        }, [
          _createElementVNode("option", _hoisted_5, _toDisplayString(_ctx.$t("please-select-visibility-level")), 1),
          _createElementVNode("option", _hoisted_6, _toDisplayString(_ctx.$t("do-not-list-on-directory")), 1),
          _createElementVNode("option", _hoisted_7, _toDisplayString(_ctx.$t("list-on-directory")), 1),
          _createElementVNode("option", _hoisted_8, _toDisplayString(_ctx.$t("list-on-directory-as-private")), 1)
        ], 544), [
          [_vModelSelect, visibility.value]
        ])
      ])
    ])
  ], 2))
}
}

})